import React, { useRef, useState, useEffect } from 'react'
import { Link } from 'gatsby'
import SbEditable from 'storyblok-react'
import classnames from 'classnames'
import { scroller } from 'react-scroll'
import gsap from 'gsap'

import TextRenderer from './../TextRenderer'
import ButtonPrimary from './../ButtonPrimary'

import styles from './styles.module.scss'

const ContentGrid = (props) => {

    // Refs
    const descriptionRef = useRef(null)
    const descriptionInnerRef = useRef(null)

    // States
    const [teamInModal, setTeamInModal] = useState(typeof window != 'undefined' && window.innerWidth > 900 ? true : false)
    const [contentItems, setContentItems] = useState(props.type == 'team' ? props.data[props.blok.members] : props.data['careers'])
    const [currentItemIndex, setCurrentItemIndex] = useState(-1)
    const [currentDescription, setCurrentDescription] = useState(null)
    const [contentRowStyles, setContentRowStyles] = useState({
        start: 2,
        end: 3
    })
    
    const toggleContentDialog = (content, index) => {
        
        const itemRow = typeof window != 'undefined' && window.innerWidth > 900 ? Math.floor(index / 5) : Math.floor(index / 2)

        // Apply styles
        setContentRowStyles({
            start: 2 + itemRow,
            end: 3 + itemRow
        })

        // Propogate content
        if (index == currentItemIndex) {
            setCurrentDescription(null)
            setCurrentItemIndex(-1)
        } else {
            setCurrentDescription(content)
            setCurrentItemIndex(index)
        }
    }

    useEffect(() => {

        const timeline = gsap.timeline()
        const headerHeight = document.querySelector('header').clientHeight
        const itemRef = props.type == 'team' ? `${props.blok.members}-grid-item-${currentItemIndex}` : `grid-item-${currentItemIndex}`
        
        if (currentItemIndex == -1) {
            return
        }

        scroller.scrollTo(itemRef, {
            duration: 1500,
            delay: 100,
            offset: -headerHeight,
            smooth: 'easeOutQuint'
        })

        gsap.to(descriptionRef.current, { height: '100%', duration: 0.25, ease: 'easeOutQuint' }, 0.0)
        gsap.fromTo(descriptionInnerRef.current, { alpha: 0.0 }, { alpha: 1.0, duration: 0.35, ease: 'easeOutQuint' }, 0.25)

        return () => {
            timeline && timeline.kill()
        }
    }, [contentRowStyles])
    
    useEffect(() => {
        
        gsap.set(descriptionRef.current, { height: 0.0 })
        gsap.set(descriptionInnerRef.current, { alpha: 0.0 })

    }, [])

    return (
        <SbEditable content={props.blok}>
            <section className={styles['content-grid']}>
                <div className='container'>
                    <h2 className={`heading-1 ${styles['content-grid__heading']}`}><b>{props.blok.heading}</b></h2>
                </div>
                <ul className={`list ${styles['content-grid__list']}`}>
                    {contentItems.nodes.map((item, i) => {
                        
                        let content = JSON.parse(item.content)

                        if (content.inactive) return

                        const itemClasses = classnames({
                            [styles['content-grid__list-item']]: true,
                            [styles['content-grid__list-item--center']]: props.type == 'careers',
                            [styles['content-grid__list-item--active']]: currentItemIndex == i
                        })

                        if (props.type == 'team') {
                            return (
                                <SbEditable key={i} content={item}>
                                    <li id={props.type == 'team' ? `${props.blok.members}-grid-item-${i}` : `grid-item-${i}`} className={itemClasses}>
                                        <Link to={`/our-team/${item.slug}/`} state={{ modal: teamInModal, noScroll: true, content: item }}>
                                            <div className={styles['grid-item__inner']}>
                                                <div className={styles['grid-item__header']}>
                                                    <h4 className={`body ${styles['grid-item__name']}`}><b>{props.type == 'team' ? item.name : content.title}</b></h4>
                                                    <p className={`body ${styles['grid-item__title']}`}>{props.type == 'team' ? content.title : content.location}</p>
                                                    {props.type == 'careers' && <p className={`body ${styles['grid-item__title']}`}>{content.terms}</p>}
                                                </div>
                                                {content.image && content.image.filename && (
                                                    <figure className={styles['grid-item__image-wrapper']} style={{ color: content.background_color == '#FFFFFF' ? '#9860FF' : content.background_color }}>
                                                        <img className={styles['grid-item__image']} src={content.image.filename} alt={content.image.alt || `Equalize Health ${item.name}`} />
                                                    </figure>
                                                )}
                                            </div>
                                        </Link>
                                    </li>
                                </SbEditable>    
                            )
                        } else {
                            <SbEditable key={i} content={item}>
                                <li id={props.type == 'team' ? `${props.blok.members}-grid-item-${i}` : `grid-item-${i}`} className={itemClasses} onClick={() => toggleContentDialog(content, i)} style={{ color: content.background_color == '#FFFFFF' ? '#9860FF' : content.background_color }}>
                                    <div className={styles['grid-item__inner']}>
                                        <div className={styles['grid-item__header']}>
                                            <h4 className={`body ${styles['grid-item__name']}`}><b>{props.type == 'team' ? item.name : content.title}</b></h4>
                                            <p className={`body ${styles['grid-item__title']}`}>{props.type == 'team' ? content.title : content.location}</p>
                                            {props.type == 'careers' && <p className={`body ${styles['grid-item__title']}`}>{content.terms}</p>}
                                        </div>
                                        {content.image && content.image.filename && (
                                            <figure className={styles['grid-item__image-wrapper']} style={{ color: content.background_color == '#FFFFFF' ? '#9860FF' : content.background_color }}>
                                                <img className={styles['grid-item__image']} src={content.image.filename} alt={content.image.alt || `Equalize Health ${item.name}`} />
                                            </figure>
                                        )}
                                    </div>
                                </li>
                            </SbEditable>
                        }
                    })}
                    <li ref={descriptionRef} className={styles['content-grid__list-content']} style={{ gridRowStart: contentRowStyles.start, gridRowEnd: contentRowStyles.end }}>
                        <div className='container'>
                            <div ref={descriptionInnerRef} className={styles['grid-item__content']}>
                                {currentDescription && (
                                    <div className={styles['grid-item__content-inner']}>
                                        {props.type == 'team' && (
                                            <>
                                                <h4 className={`heading-4 ${styles['grid-item__name']}`}><b>{currentDescription.name}</b></h4>
                                                <p className={`heading-4 ${styles['grid-item__title']} ${styles['grid-item__title--description']}`}>{currentDescription.title}</p>
                                            </>
                                        )}
                                        {props.type == 'careers' && (
                                            <>
                                                <h4 className={`heading-4 ${styles['grid-item__name']}`}><b>{currentDescription.title}</b></h4>
                                                <p className={`heading-4 ${styles['grid-item__title']} ${styles['grid-item__title--description']}`}>{currentDescription.location}</p>
                                                <p className={`heading-4 ${styles['grid-item__title']} ${styles['grid-item__title--description']}`}>{currentDescription.terms}</p>
                                            </>
                                        )}
                                        <TextRenderer text={currentDescription.description} />
                                        {currentDescription.download && (
                                            <ButtonPrimary className={styles['grid-item__download-button']} label='Download PDF' link={currentDescription.download} />
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </li>
                </ul>
            </section>
        </SbEditable>
    )
}

export default ContentGrid